module.exports = {
    //SecertKey: 'cd05e401-a0fa-4cd4-9a07-bee2e9284efc',
    // SecertKey: '2ab95587-2a96-46ee-978b-1dc6065d2b29',
    // SecertKey: 'b6c9a2b1-8eb3-484e-b44d-a6a45b56b5ae',
    SecertKey: 'd9379269-5110-4fbf-bb3a-ba316147071a',
    // SecertKey: 'df0895cc-f2db-4954-9ed5-13365f1ea2cd',

    // SecertKey: '1d2e9508-0d2e-40d0-8e86-d5f1d7ad0582',



    // SecertKey: 'df0895cc-f2db-4954-9ed5-13365f1ea2cd',
    RoutUser: '/user/home',
    Theme: 'blackpink',

    // all Theme
    //  darkred
    // darkgreen
    // default
    // pgsure
    // wws
    // blackpink
    // gold
    // light
    // dark

}


// WEBPACK FOOTER //
// ./src/config/index.js